import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_regarding_wo'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_regarding_wo',
  name: 'Does the facility follow any of the following practices regarding working hour records?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_ARE_MAINTAINED_FOR_AT_LEAS',
      text: 'Working hour records for each worker are maintained for at least the last 12 months',
      externalIds: [
        {
          id: 'wh-3--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_S_REGULAR_AND_OVERTIME_HOU',
      text: "Working hour records for each worker's regular and overtime hours are maintained",
      externalIds: [
        {
          id: 'wh-3--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'START_AND_FINISH_TIMES_ARE_RECORDED_FOR_ALL_PERIODS_OF_WORK',
      text: 'Start and finish times are recorded for all periods of work',
      externalIds: [
        {
          id: 'wh-3--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'START_AND_FINISH_TIMES_IN_THE_PAYROLL_SYSTEM_MATCH_EXACT_TIME_I',
      text: 'Start and finish times in the payroll system match exact time in/out in time records.',
      externalIds: [
        {
          id: 'wh-3--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKING_HOUR_RECORDS_ARE_CONSISTENT_WITH_PAYROLL_AND_OTHER_RECO',
      text: 'Working hour records are consistent with payroll and other records',
      externalIds: [
        {
          id: 'wh-3--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_HAVE_UNRESTRICTED_ACCESS_TO_VERIFY_THE_ACCURACY_OF_WORK',
      text: 'Workers have unrestricted access to verify the accuracy of working hours',
      externalIds: [
        {
          id: 'wh-3--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wh-3--1-7x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_ARE_MAINTAINED_FOR_AT_LEAS',
                'WORKING_HOUR_RECORDS_FOR_EACH_WORKER_S_REGULAR_AND_OVERTIME_HOU',
                'START_AND_FINISH_TIMES_ARE_RECORDED_FOR_ALL_PERIODS_OF_WORK',
                'START_AND_FINISH_TIMES_IN_THE_PAYROLL_SYSTEM_MATCH_EXACT_TIME_I',
                'WORKING_HOUR_RECORDS_ARE_CONSISTENT_WITH_PAYROLL_AND_OTHER_RECO',
                'WORKERS_HAVE_UNRESTRICTED_ACCESS_TO_VERIFY_THE_ACCURACY_OF_WORK',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-wor-5',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6500,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
